import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-patientstatusgrid',
  templateUrl: './patientstatusgrid.component.html',
  styleUrls: ['./patientstatusgrid.component.css']
})
export class PatientstatusgridComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/Pages/tasks/patientstatus/patientstatusgrid/patientstatusgrid.component.ts